import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useCookies } from 'react-cookie';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import TableHeaderFilter from '../../Common/TableHeaderFilter';
import TableContainer from '@material-ui/core/TableContainer';
import { Chip, Table, useMediaQuery, useTheme } from '@material-ui/core';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useHistory, useLocation } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import moment from 'moment';
import TablePagination from '@material-ui/core/TablePagination';
import { getQuery } from '../../../utils/common';
import {
    DeleteFirm,
    GetAddressBookAllTags,
    GetFirmsList
} from '../../../redux/Firms/actions';
import { FirmsTab, Routes, ROWS_PER_PAGE } from '../../../constants';
import { CommonPaginationAction } from '../../Users/Common/CommonPaginationAction';
import { CommonTableStyle } from '../../Common/CommonTableStyle';
import WebsiteURLWrapper from '../Common/WebsiteURLWrapper';
import TagsPopup from '../../Common/TagsPopup';
import { NoteAdd, NoteAddOutlined } from '@material-ui/icons';
import { ADD_ADDRESS_BOOK_NOTE_MODAL } from '../../../redux/ModalReducer/actionTypes';
import { CommonDispatcher } from '../../../redux/Common/action';
import { FirmsTypeList } from '../../../utils/constants';

const options = [
    { title: 'Edit', value: 'edit' },
    { title: 'Delete', value: 'delete' }
];

const InActiveComponent = ({
    sectionBaseUrl,
    GetFirmsList,
    CommonDispatcher,
    DeleteFirm,
    loading,
    isMainFilterApplied,
    getAllTabsData,
    GetAddressBookAllTags,
    getSelectedTabData,
    handleTabLoading,
    isTabLoading
}: any) => {
    const classes = CommonTableStyle();
    const [isFilterApplied, setIsFilterApplied] = useState(isMainFilterApplied);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [tableHeader, setTableHeader] = useState([]);
    const tableHeaderList = useSelector(
        (store: RootState) => store?.firms.tableHeader || []
    );
    const listingsData = useSelector(
        (store: RootState) => store?.firms?.allFirmsList
    );
    const history = useHistory();
    const query = getQuery(history);
    const type = query.get('type');
    const tags = query.get('tags_ids');
    const keyword = query.get('keyword');
    const [page, setPage] = useState(0);
    const count = listingsData?.count;
    const total_pages = listingsData?.total_pages;
    const [cookies] = useCookies(['pgAdminToken']);
    const token = cookies['pgAdminToken'];
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const filterParam = searchParams.get('filter');
    let decodedFilters;
    if (filterParam) {
        decodedFilters = JSON.parse(decodeURIComponent(filterParam));
    }

    useEffect(() => {
        setTableHeader(
            tableHeaderList.filter(
                (d) => !['firm_logo', 'show_to_user'].includes(d?.id)
            )
        );
    }, []);

    useEffect(() => {
        GetAddressBookAllTags(
            {
                page_number: 1
            },
            false,
            token
        ).then((x) => {
            setIsLoading(false);
        });
    }, []);
    useEffect(() => {
        if (
            !isFilterApplied &&
            (keyword || type || typeof page !== 'undefined')
        ) {
            getData({
                keyword,
                type,
                page: page + 1,
                filter: { tags_ids: tags ? tags?.split(',') : null },
                tab: FirmsTab.TYPE_IN_ACTIVE
            });
        }
        // eslint-disable-next-line
    }, [keyword, type, page, tags]);

    const handleClick = (event: React.MouseEvent<HTMLElement>, user) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedUser(user);
    };

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const getData = (data) => {
        data.size = ROWS_PER_PAGE;
        setIsLoading(true);
        if (filterParam || tags) {
            data.filter = {
                ...decodedFilters,
                tags_ids: tags ? tags?.split(',') : null
            };
        }
        GetFirmsList(token, data).then(() => {
            handleTabLoading(false);
            setIsLoading(false);
        });
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        setIsFilterApplied(false);
    };

    const CommonComponent = () => (
        <CommonPaginationAction
            count={count}
            page={page}
            setPage={setPage}
            total_pages={total_pages}
        />
    );

    const handleChange = (value, selectedUser) => {
        switch (value) {
            case 'edit':
                history.push(`/edit/firms/${selectedUser?.firm_id}`);
                break;
            case 'delete':
                if (
                    window?.confirm(
                        'Are you sure you want to delete this firm?'
                    )
                ) {
                    DeleteFirm(token, selectedUser?.firm_id)
                        .then(() => getSelectedTabData(page))
                        .catch(() => {
                            alert('Something went wrong.');
                        });
                }
                break;
        }
    };
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.down('md'));
    const handleAddNoteModal = (type, title, address_book) => {
        CommonDispatcher(type, {
            isOpen: true,
            title,
            data: {
                disableBackdropClick: true,
                data: { address_book }
            },
            submitTitle: 'Save',
            cancelTitle: 'Cancel'
        });
    };
    const renderAddNote = (d) => {
        return (
            // <div className={style.addNote}>
            <IconButton
                aria-label="edit"
                onClick={(e) => {
                    e.stopPropagation();
                    handleAddNoteModal(ADD_ADDRESS_BOOK_NOTE_MODAL, `Note`, d);
                }}
            >
                <NoteAddOutlined fontSize="medium" className="colorGray" />
            </IconButton>
            // </div>
        );
    };

    const renderNote = (d) => {
        return (
            // <div className={style.noteAdded}>
            <IconButton
                aria-label="edit"
                onClick={(e) => {
                    e.stopPropagation();
                    handleAddNoteModal(ADD_ADDRESS_BOOK_NOTE_MODAL, `Note`, d);
                }}
            >
                <NoteAdd fontSize="medium" className="colorPurple" />
            </IconButton>
            // </div>
        );
    };

    const renderMenu = ({ firm_id, label }) => {
        return (
            <>
                <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={(e) => handleClick(e, { firm_id, label })}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    elevation={0}
                    PaperProps={{
                        style: {
                            // maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                            border: '1px solid rgb(0 106 194 / 20%)'
                        }
                    }}
                >
                    {options.map((option, i) => (
                        <MenuItem
                            key={option?.value}
                            onClick={() => {
                                handleChange(option?.value, selectedUser);
                                setAnchorEl(null);
                            }}
                        >
                            {option?.title}
                        </MenuItem>
                    ))}
                </Menu>
            </>
        );
    };

    return (
        <Grid container spacing={0} className="h-100">
            <Grid item xs={12}>
                <Paper className={classes.root}>
                    <TableHeaderFilter
                        filterDataArray={FirmsTypeList}
                        tab={FirmsTab.TYPE_IN_ACTIVE}
                    />
                    {loading || isLoading || isTabLoading ? (
                        <div className="mainLoader">
                            <div className="loader" />
                        </div>
                    ) : (
                        <>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {tableHeader?.map((column) => (
                                                <TableCell key={column.id}>
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listingsData?.posts &&
                                        listingsData?.posts.length ? (
                                            listingsData?.posts?.map((row) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row?.firm_id}
                                                        style={{
                                                            padding: 0,
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <TableCell
                                                            size={'small'}
                                                            onClick={(e) =>
                                                                e.stopPropagation()
                                                            }
                                                        >
                                                            {renderMenu(row)}
                                                        </TableCell>
                                                        <TableCell
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <TagsPopup
                                                                d={row}
                                                            />
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                minWidth:
                                                                    '100px'
                                                            }}
                                                            size={'small'}
                                                        >
                                                            {moment(
                                                                row?.joining_date
                                                            ).format(
                                                                'DD MMM, YYYY'
                                                            )}
                                                        </TableCell>
                                                        <TableCell
                                                            size={'small'}
                                                        >
                                                            <Chip
                                                                size="small"
                                                                label={
                                                                    row?.is_active
                                                                        ? 'Active'
                                                                        : 'InActive'
                                                                }
                                                                clickable
                                                                color={
                                                                    row?.is_active
                                                                        ? 'primary'
                                                                        : 'secondary'
                                                                }
                                                            />
                                                        </TableCell>
                                                        <TableCell
                                                            size={'small'}
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <div className="d-flex mr-2 ">
                                                                    {row?.label ||
                                                                        '-'}
                                                                </div>
                                                                {!isTabletScreen ? (
                                                                    <>
                                                                        {row?.note
                                                                            ? renderNote(
                                                                                  row
                                                                              )
                                                                            : renderAddNote(
                                                                                  row
                                                                              )}
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell
                                                            size={'small'}
                                                        >
                                                            <WebsiteURLWrapper
                                                                website={
                                                                    row?.website
                                                                }
                                                            >
                                                                {row?.website ||
                                                                    '-'}
                                                            </WebsiteURLWrapper>
                                                        </TableCell>
                                                        <TableCell
                                                            size={'small'}
                                                        >
                                                            {row?.type ? (
                                                                <Chip
                                                                    size="small"
                                                                    label={
                                                                        row?.type
                                                                    }
                                                                    color={
                                                                        row?.type ===
                                                                        'INVESTOR'
                                                                            ? 'primary'
                                                                            : 'secondary'
                                                                    }
                                                                    clickable
                                                                />
                                                            ) : (
                                                                '-'
                                                            )}
                                                        </TableCell>
                                                        <TableCell
                                                            size={'small'}
                                                        >
                                                            {row?.users &&
                                                            row?.users?.length
                                                                ? row?.users.map(
                                                                      (d) => {
                                                                          return (
                                                                              <a
                                                                                  href={`${Routes.users.viewUser.replace(
                                                                                      ':user_id',
                                                                                      d?.user_id
                                                                                  )}`}
                                                                                  target="_blank"
                                                                                  rel="noopener noreferrer"
                                                                                  className="text-decoration-none colorPrimary"
                                                                                  key={
                                                                                      d?.user_id
                                                                                  }
                                                                              >
                                                                                  <Chip
                                                                                      size="small"
                                                                                      className="mr-2 my-2"
                                                                                      label={
                                                                                          d?.full_name
                                                                                      }
                                                                                      clickable
                                                                                  />
                                                                              </a>
                                                                          );
                                                                      }
                                                                  )
                                                                : '-'}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={
                                                        tableHeader.length + 1
                                                    }
                                                    className="dataNotAvailable"
                                                >
                                                    Data not available
                                                </td>
                                            </tr>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                className={classes.footer}
                                hidden={
                                    listingsData?.posts &&
                                    !listingsData?.posts.length
                                }
                                rowsPerPageOptions={[]}
                                component="div"
                                count={count}
                                rowsPerPage={listingsData?.page_size}
                                page={page}
                                ActionsComponent={CommonComponent}
                                onPageChange={handleChangePage}
                            />
                        </>
                    )}
                </Paper>
            </Grid>
        </Grid>
    );
};
export default connect(null, {
    GetFirmsList,
    DeleteFirm,
    GetAddressBookAllTags,
    CommonDispatcher
})(InActiveComponent);
